import { useQuery } from 'react-query';
import ReferralTypeService from '../../services/referralTypeService';

export type UseReferralTypesReturn = {
  referralTypes: Array<{ value: ?string, text: string }>,
  isLoading: boolean,
};

export default function useReferralTypes(): UseReferralTypesReturn {
  const queryKey = 'referralTypes';
  const referralTypeService = new ReferralTypeService();

  const { data, isLoading } = useQuery(
    queryKey,
    () => {
      return referralTypeService.getAll();
    },
    { initialData: [], refetchOnWindowFocus: false },
  );

  const dataToReturn = !isLoading
    ? data
        .map((referralType) => ({
          value: referralType.id,
          text: referralType.name,
        }))
        .sort((a, b) => a.text.localeCompare(b.text))
    : null;

  return {
    referralTypes: dataToReturn,
    isLoading,
  };
}
